import React, { useState, useEffect, useContext } from "react";
import {
  Avatar1,
  Avatar2,
  cameraicon,
  doctor,
  imagesend,
  lines,
  menuicon16,
  profileuser01,
  monitorIcon,
  tratamientoIcon,
  contactIcon,
  condicionesIcon,
  editarperfil,
} from "../imagepath";

import FeatherIcon from "feather-icons-react";
import { Link } from "react-router-dom";
import { Modal, message, Skeleton } from "antd";
import {
  getPatientDemographics,
  updatePatientStatus,
  getPatientsFilters,
  getNeighborhoods,
} from "../../services/patient";
import DatosClinicos from "./DatosClinicos/DatosClinicos";
import HealthProfile from "./HealthProfile";
import PlanCuidado from "./PlanCuidado/PlanCuidado";
import { PlanCuidadoContextProvider } from "../../context/PlanCuidadoContextProvider";
import { useParams } from "react-router-dom";
import { MedicInformationContextProvider } from "../../context/MedicInformationContextProvider";
import PatientesTreatment from "./PatientesTreatment";
import PatientsMedicCondition from "./PatientsMedicCondition";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { patientStatusCode } from "../../utils/enums/statusCodes";
import { GestoresContextProvider } from "../../context/GestoresContext";
import Documentacion from "./Soporte/Documentacion";
import { DocumentacionContextProvider } from "../../context/DocumentacionContext";
import RegisterPatient from "./RegisterPatient";
import patientModes from "../../utils/enums/patientModes";
import { getInitials } from "../../utils/helpers";

const WarningIcon = () => (
  <span
    className="fas fa-exclamation-triangle"
    style={{
      marginRight: "0.85em",
      color: "grey",
      fontSize: "16px",
    }}
  ></span>
);

const PatientsProfile = () => {
  const [patientData, setPatientData] = useState(null);
  const [loading, setLoading] = useState(true);
  //Modal for Edit Patient Information
  const [options, setOptions] = useState([]);
  const [IsModalOpen, setIsModalOpen] = useState(false);
  const [patientModal, setPatientModal] = useState({
    InsuredMember: "",
    name: "",
    email: "",
    telephone: "",
    address: "",
    manager: "",
    pathology: "",
    pathologyId: "",
    currentPathology: "",
    dateOfBirth: "",
    age: "",
    pss: {},
    pssId: "",
    municipality: {},
    municipalityId: "",
    neighboordhood: {},
    DemograficCd: "",
  });
  let { id } = useParams();

  const onChangeStatus = (newStatusDescription, newStatus) => {
    try {
      const { confirm } = Modal;
      confirm({
        title: "Actualización Estado Paciente",
        icon: <ExclamationCircleFilled />,
        content:
          "¿Está seguro que desea actualizar el estado del paciente a " +
          newStatusDescription +
          "?",
        okText: "Si",
        cancelText: "No",
        onOk() {
          //Call API
          return new Promise((resolve, reject) => {
            updatePatientStatus({
              insuredMember: id,
              StatusCode: newStatus,
            }).then(() => {
              fetchPatientData();
              resolve();
            });
          }).catch(() => console.log("Oops errors!"));
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } catch (error) {
      console.error(error);
    }
  };
  const onClickEditPatient = () => {
    setPatientModal({
      InsuredMember: id,
      name: patientData.nombreCompleto,
      email: patientData.email,
      //Set Format Phone in (xxx) xxx-xxxx
      telephone: patientData.telefono.replace(
        /(\d{3})(\d{3})(\d{4})/,
        "($1) $2-$3"
      ),
      managerId: patientData.gestorInfo.gestorCd,
      pathologyId: patientData.patologia.patologiaCd,
      currentPathology: patientData.patologia.patologia,
      // dateOfBirth: record.dateOfBirth,
      age: patientData.edad,

      address: patientData.datosDemograficos.direccion,
      municipalityId:
        patientData.datosDemograficos != undefined
          ? patientData.datosDemograficos.municipioCd
          : "",
      neighborhoodId:
        patientData.datosDemograficos != undefined
          ? patientData.datosDemograficos.datoDemograficoCd
          : "",
      pss: patientData.gestorInfo.pssCd,
      gender: patientData.genero,
    });
    setIsModalOpen(true);
  };

  const onCloseModal = () => {
    setIsModalOpen(false);
  };

  const OnCompleteModal = async () => {
    setLoading(true);
    setIsModalOpen(false);
    await fetchPatientData();
  };

  const fetchPatientData = async () => {
    try {
      const data = await getPatientDemographics(id);
      setPatientData(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchPatientData();
  }, []);

  useEffect(() => {
    if (
      patientData &&
      patientData.datosDemograficos &&
      patientData.datosDemograficos.municipioCd
    ) {
      getNeighborhoods(patientData.datosDemograficos.municipioCd).then(
        (data) => {
          const neighboordhoods = data.map((item) => ({
            value: item.key,
            label: item.value,
          }));
          getPatientsFilters().then((response) => {
            const pathologies = response.pathologies.map((item) => ({
              value: item.key,
              label: item.value,
            }));
            const managers = response.managers.map((item) => ({
              value: item.key,
              label: item.value,
              pss: item.pss,
            }));

            const pss = response.pss.map((item) => ({
              value: item.key,
              label: item.value,
            }));

            const municipalities = response.municipios.map((item) => ({
              value: item.key,
              label: item.value,
            }));

            const generos = response.generos.map((item) => ({
              value: item.key,
              label: item.value,
            }));
            setOptions({
              managers: managers,
              pathologies: pathologies,
              pss: pss,
              municipalities: municipalities,
              neighboordhoods: neighboordhoods,
              genders: generos,
            });
          });
        }
      );
    } else {
      getPatientsFilters().then((response) => {
        const pathologies = response.pathologies.map((item) => ({
          value: item.key,
          label: item.value,
        }));
        const managers = response.managers.map((item) => ({
          value: item.key,
          label: item.value,
          pss: item.pss,
        }));

        const pss = response.pss.map((item) => ({
          value: item.key,
          label: item.value,
        }));

        const municipalities = response.municipios.map((item) => ({
          value: item.key,
          label: item.value,
        }));

        const generos = response.generos.map((item) => ({
          value: item.key,
          label: item.value,
        }));

        setOptions({
          managers: managers,
          pathologies: pathologies,
          pss: pss,
          municipalities: municipalities,
          neighboordhoods: [],
          genders: generos,
        });
      });
    }
  }, [patientData]);

  return (
    <div>
      <>
        <>
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Paciente </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">
                    Expediente de Salud
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-lg-4 col-md-4">
                          <div className="profile-user-box">
                            <div className="profile-user-img">
                              {patientData ? (
                                <h2>
                                  {getInitials(patientData.nombreCompleto)}
                                </h2>
                              ) : (
                                <Skeleton.Avatar active />
                              )}
                            </div>
                            {patientData ? (
                              <div className="doctor-follows">
                                <h4>Nombre</h4>
                                <h5>{patientData.nombreCompleto}</h5>
                              </div>
                            ) : (
                              <div>
                                <Skeleton active />
                              </div>
                            )}
                          </div>
                        </div>
                        {patientData ? (
                          <div className="col-lg-4 col-md-4 d-flex align-items-center">
                            <div className="follow-group">
                              <div className="doctor-follows">
                                <h4>Documento</h4>
                                <h5>
                                  {patientData.documento != undefined
                                    ? patientData.documento.replace(
                                        /(\d{3})(\d{7})(\d{1})/,
                                        "$1-$2-$3"
                                      )
                                    : "-"}
                                </h5>
                              </div>
                              <div className="doctor-follows">
                                <h4>Edad</h4>
                                <h5>{patientData.edad}</h5>
                              </div>
                              <div className="doctor-follows">
                                <h4>Género</h4>
                                <h5>
                                  {patientData.genero === "F"
                                    ? "Femenino"
                                    : "Masculino"}
                                </h5>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="col-lg-4 col-md-4 d-flex align-items-center">
                            <div>
                              <Skeleton active />
                            </div>
                          </div>
                        )}
                        {patientData ? (
                          <div className="col-lg-4 col-md-4 d-flex align-items-center">
                            <div className="btn-group">
                              <button
                                type="button"
                                className="btn btn-primary dropdown-toggle me-1"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                {patientData.status}
                              </button>
                              <div className="dropdown-menu">
                                <Link
                                  className="dropdown-item"
                                  to="#"
                                  onClick={() =>
                                    onChangeStatus(
                                      patientStatusCode.Rolled.text,
                                      patientStatusCode.Rolled.value
                                    )
                                  }
                                >
                                  {patientStatusCode.Rolled.text}
                                </Link>
                                <Link
                                  className="dropdown-item"
                                  to="#"
                                  onClick={() =>
                                    onChangeStatus(
                                      patientStatusCode.Inactive.text,
                                      patientStatusCode.Inactive.value
                                    )
                                  }
                                >
                                  {patientStatusCode.Inactive.text}
                                </Link>
                                <Link
                                  className="dropdown-item"
                                  to="#"
                                  onClick={() =>
                                    onChangeStatus(
                                      patientStatusCode.Suspended.text,
                                      patientStatusCode.Suspended.value
                                    )
                                  }
                                >
                                  {patientStatusCode.Suspended.text}
                                </Link>
                                <Link
                                  className="dropdown-item"
                                  to="#"
                                  onClick={() =>
                                    onChangeStatus(
                                      patientStatusCode.Deceased.text,
                                      patientStatusCode.Deceased.value
                                    )
                                  }
                                >
                                  {patientStatusCode.Deceased.text}
                                </Link>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="col-lg-4 col-md-4 d-flex align-items-center">
                            <div>
                              <Skeleton.Button active />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lines-profile">
                  <span className="azul"></span>
                  <span className="azulOscuro"></span>
                  <span className="verder"></span>
                  <span className="verderOscuro"></span>
                </div>
                <img className="lines-profile" src={lines} />
              </div>
              <div className="row">
                <div className="col-lg-3">
                  <div className="doctor-personals-grp">
                    <div className="card">
                      <div className="card-body">
                        <div className="heading">
                          <div className="heading-detail">
                            <img src={contactIcon} width="20px" height="20px" />
                            <h4>Datos de contacto</h4>
                          </div>
                          {options && !loading && (
                            <Link
                              className="btn btn-primary btn-sm editar"
                              to="#"
                              onClick={onClickEditPatient}
                            >
                              <img 
                              width={12}
                              height={12}
                              className="far me-2"
                              src={editarperfil} alt=""/>
                              Editar
                            </Link>
                          )}
                        </div>
                        <div className="about-me-list">
                          <ul className="list-space">
                            <li>
                              <h4>PSS:</h4>
                              {loading && patientData == undefined ? (
                                <Skeleton active />
                              ) : (
                                <span>{patientData.gestorInfo.pss}</span>
                              )}
                            </li>
                            <li>
                              <h4>Teléfono: </h4>
                              {loading && patientData == undefined ? (
                                <Skeleton active />
                              ) : (
                                <span>
                                  {patientData.telefono != undefined
                                    ? patientData.telefono.replace(
                                        /(\d{3})(\d{3})(\d{4})/,
                                        "($1) $2-$3"
                                      )
                                    : "-"}
                                </span>
                              )}
                            </li>
                            <li>
                              <h4>Dirección:</h4>
                              {loading && patientData == undefined ? (
                                <Skeleton active />
                              ) : (
                                <span>
                                  {patientData.datosDemograficos.direccion},{" "}
                                  {patientData.datosDemograficos.sector},{" "}
                                  {patientData.datosDemograficos.municipio}
                                </span>
                              )}
                            </li>
                            <li>
                              <h4>Email:</h4>
                              {loading && patientData == undefined ? (
                                <Skeleton active />
                              ) : (
                                <span>{patientData.email}</span>
                              )}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="doctor-personals-grp">
                    <div className="card">
                      <div className="card-body">
                        <div className="heading">
                          <div className="heading-detail">
                            <img src={monitorIcon} width="20px" height="20px" />
                            <h4>Monitoreo</h4>
                          </div>
                        </div>
                        {/* <div>
                          <div>
                            <h5>
                              <span style={{ color: "red" }}>0</span>{" "}
                              Intervenciones pendientes
                            </h5>
                          </div>

                          <div>
                            <h5>
                              <span style={{ color: "red" }}>0</span> Cita
                              pendiente
                            </h5>
                          </div>
                        </div> */}
                        <div className="body-no-data">
                          <h4>Sin datos para mostrar</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="doctor-personals-grp">
                    <div className="card">
                      <MedicInformationContextProvider>
                        <PatientsMedicCondition />
                      </MedicInformationContextProvider>
                    </div>
                  </div>
                  <div className="doctor-personals-grp">
                    <div className="card">
                      <MedicInformationContextProvider>
                        <PatientesTreatment />
                      </MedicInformationContextProvider>
                    </div>
                  </div>
                </div>
                <div className="col-lg-9">
                  <div className="card">
                    <div className="card-body">
                      <div className="tab-content-set">
                        <ul className="nav">
                          <li>
                            <Link
                              to="#top-tab1"
                              data-bs-toggle="tab"
                              className="nav-link active"
                            >
                              <span className="set-about-icon me-2">
                                <img src={doctor} alt="" />
                              </span>
                              Expediente de Salud
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#top-tab2"
                              data-bs-toggle="tab"
                              className="nav-link"
                            >
                              <span className="set-about-icon me-2">
                                <img src={doctor} alt="" />
                              </span>
                              Información Médica
                            </Link>
                          </li>
                          <li>
                            <Link
                              data-bs-toggle="tab"
                              className="nav-link"
                              to="#top-tab4"
                            >
                              <span className="set-about-icon me-2">
                                <img src={menuicon16} alt="" />
                              </span>
                              Estrategias de Cuidado
                            </Link>
                          </li>
                          <li>
                            <Link
                              data-bs-toggle="tab"
                              className="nav-link"
                              to="#top-tab5"
                            >
                              <span className="set-about-icon me-2">
                                <img src={menuicon16} alt="" />
                              </span>
                              Datos de Soporte
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="tab-content">
                        <div className="tab-pane show active" id="top-tab1">
                          <HealthProfile />
                        </div>
                        <div className="tab-pane" id="top-tab2">
                          <GestoresContextProvider>
                            <MedicInformationContextProvider>
                              <DatosClinicos />
                            </MedicInformationContextProvider>
                          </GestoresContextProvider>
                        </div>
                        <div className="tab-pane" id="top-tab4">
                          <GestoresContextProvider>
                            <PlanCuidadoContextProvider>
                              <PlanCuidado />
                            </PlanCuidadoContextProvider>
                          </GestoresContextProvider>
                        </div>
                        <div className="tab-pane" id="top-tab5">
                          <DocumentacionContextProvider>
                            <Documentacion />
                          </DocumentacionContextProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="notification-box">
            <div className="msg-sidebar notifications msg-noti">
              <div className="topnav-dropdown-header">
                <span>Messages</span>
              </div>
              <div className="drop-scroll msg-list-scroll" id="msg_list">
                <ul className="list-box">
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">R</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Richard Miles </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item new-message">
                        <div className="list-left">
                          <span className="avatar">J</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">John Doe</span>
                          <span className="message-time">1 Aug</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">T</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Tarah Shropshire{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">M</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Mike Litorus</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">C</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Catherine Manseau{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">D</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Domenic Houston{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">B</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Buster Wigton{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">R</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Rolland Webber{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">C</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author"> Claire Mapes </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">M</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Melita Faucher</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">J</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Jeffery Lalor</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">L</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Loren Gatlin</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">T</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            Tarah Shropshire
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="chat.html">See all messages</Link>
              </div>
            </div>
          </div>
          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="" width={50} height={46} />
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button type="submit" className="btn btn-danger">
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RegisterPatient
            affiliateData={patientModal}
            open={IsModalOpen}
            onClose={onCloseModal}
            OnCompleteModal={OnCompleteModal}
            options={options}
            mode={patientModes.Actualizacion}
          />
        </>
      </>
    </div>
  );
};

export default PatientsProfile;
